export function isEphemeralImageUrl(value) {
  return typeof value === 'string' && value.trim().startsWith('blob:');
}

export function isPersistentImageUrl(value) {
  return Boolean(
    typeof value === 'string' &&
      value.trim() &&
      !value.trim().startsWith('blob:') &&
      !value.trim().startsWith('data:'),
  );
}

export function persistentOriginalForEdit(imageState = {}) {
  const candidates = [
    imageState.resultImage,
    imageState.serverImageUrl,
    imageState.uploadedImageUrl,
  ];
  return candidates.find(isPersistentImageUrl) || '';
}

export function restorePersistedImageState(imageState = {}) {
  const stableUploadUrl = isPersistentImageUrl(imageState.serverImageUrl)
    ? imageState.serverImageUrl
    : null;
  const uploadedImageUrl = isEphemeralImageUrl(imageState.uploadedImageUrl)
    ? stableUploadUrl
    : imageState.uploadedImageUrl;

  return {
    ...imageState,
    uploadedImage: null,
    uploadedImageUrl,
    currentTaskImageUrl: isEphemeralImageUrl(imageState.currentTaskImageUrl)
      ? stableUploadUrl
      : imageState.currentTaskImageUrl,
    taskOriginalImageUrl: isEphemeralImageUrl(imageState.taskOriginalImageUrl)
      ? stableUploadUrl
      : imageState.taskOriginalImageUrl,
  };
}

export function repairDashboardTaskOriginals(
  tasks = [],
  history = [],
  constructUrl = value => value || '',
  activeTask = {},
) {
  const historyByProcessId = new Map(
    history
      .filter(item => item?.process_id != null)
      .map(item => [String(item.process_id), item]),
  );

  return tasks.map(task => {
    if (isPersistentImageUrl(task?.originalImage)) return task;

    const activeOriginal = activeTask?.originalImage;
    if (
      task?.id != null &&
      activeTask?.id != null &&
      String(task.id) === String(activeTask.id) &&
      isPersistentImageUrl(activeOriginal)
    ) {
      return { ...task, originalImage: constructUrl(activeOriginal) };
    }

    const historyItem = task?.process_id == null
      ? null
      : historyByProcessId.get(String(task.process_id));
    const historyOriginal = historyItem?.original_url;
    if (!isPersistentImageUrl(historyOriginal)) return task;

    const repairedOriginal = constructUrl(historyOriginal);
    if (repairedOriginal === task.originalImage) return task;
    return { ...task, originalImage: repairedOriginal };
  });
}
